module.exports = __webpack_public_path__ + "img/rugbyLes2.3de537b8.jpg";